var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CustomFieldsModel } from '../models/custom-fields-model.interface';
import { CustomFieldsRepository } from '../repositories/custom-fields-repository.interface';
let CustomFieldsServiceImpl = class CustomFieldsServiceImpl {
    constructor(_customFieldsModel, _customFieldsRepository) {
        this._customFieldsModel = _customFieldsModel;
        this._customFieldsRepository = _customFieldsRepository;
    }
    updateFields(fields) {
        this._customFieldsModel.update(model => {
            model.fields = fields;
            return model;
        });
    }
    async query(queryCompanyCustomFieldOrNot) {
        const state = await this._getFields(queryCompanyCustomFieldOrNot);
        this._customFieldsModel.update(() => state);
        return state;
    }
    _getFields(isPublic) {
        return this._customFieldsRepository.queryFields(isPublic);
    }
};
CustomFieldsServiceImpl = __decorate([
    injectable(),
    __param(0, inject(CustomFieldsModel)),
    __param(1, inject(CustomFieldsRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof CustomFieldsModel !== "undefined" && CustomFieldsModel) === "function" ? _a : Object, typeof (_b = typeof CustomFieldsRepository !== "undefined" && CustomFieldsRepository) === "function" ? _b : Object])
], CustomFieldsServiceImpl);
export { CustomFieldsServiceImpl };
